
/** @format */

import React, { useEffect } from 'react';
import { useStyles } from './style';
import { Grid, Typography } from '@mui/material';
import { Icons } from 'components';
import Skeleton from '@mui/material/Skeleton';
import AssignedDelegationServices from '../../services/ReceivedDelegationServices';
import useCustomHook from './hooks';

const DetailPanel = ({ delegationId }) => {
  // -- STATES --//
  const { loading, setLoading, data, setData } = useCustomHook();

  // --HOOKS--//
  const classes = useStyles();

  useEffect(() => {
    if (delegationId) {
      getDelegations();
    }
  }, [delegationId]);

  const getDelegations = async () => {
    try {
      setLoading(true);

      const params = {
        delegationId,
      };

      const data = {
        filterVOS: [],
        parentParams: [],
        orderByElementVOS: [],
      };

      const res = await AssignedDelegationServices.getUsageRestrictions(data, params);
      setData(normalizeData(res.result.rows));

      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const normalizeData = (data) => {
    const bizsList = [];
    const guildsList = [];
    const productsList = [];

    data.forEach((row, k) => {
      if (row?.cols[1] && row?.cols[2]) {
        const d = {
          id: row?.cols[1],
          value: row?.cols[2],
        };
        if (!bizsList.includes(d)) {
          bizsList.push(d);
        }
      }
      if (row?.cols[3] && row?.cols[4]) {
        const d = {
          id: row?.cols[3],
          value: row?.cols[4],
        };
        if (!guildsList.includes(d)) {
          guildsList.push(d);
        }
      }
      if (row?.cols[5] && row?.cols[6]) {
        const d = {
          id: row?.cols[5],
          value: row?.cols[6],
        };
        if (!productsList.includes(d)) {
          productsList.push(d);
        }
      }
    });

    return {
      bizs: bizsList,
      guilds: guildsList,
      products: productsList,
    };
  };

  // -- LOCAL VARIABLES--//

  return (
    <>
      <Grid container direction="column" className={classes.props}>
        {loading ? (
          <>
            <Skeleton
              variant="text"
              style={{ width: '20%', height: 20 }}
              className={classes.propsTitle}
            />
            {[1, 2, 3].map((v, k) => (
              <Grid key={k} container alignItems="center" className={classes.tickItem}>
                <Skeleton
                  variant="circular"
                  style={{ width: 16, height: 16 }}
                  className={classes.tickIcon}
                />
                <Skeleton
                  variant="text"
                  style={{ width: '25%', height: 15 }}
                  className={classes.tickText}
                />
              </Grid>
            ))}
          </>
        ) : (
          <>
            <Grid
              container
              alignItems={data?.bizs.length === 0 ? 'center' : 'flex-start'}
              className={classes.tickItem}
            >
              <span className={classes.tickIcon}>
                <Icons icon='Accept' color='#4CAF50' size='22' />
              </span>
              <Typography className={classes.tickText}>
                {data?.bizs.length === 0
                  ? 'امکان استفاده از این اعتبار در تمامی کسب‌و‌کارها وجود دارد.'
                  : `امکان استفاده از این اعتبار در کسب‌وکارهای زیر وجود دارد:`}
                <br />
                {data?.bizs.map((v, k) => (
                  <li key={k} className={classes.usageItem}>{`${v.value} (شناسه کسب‌وکار ${v.id})${k < data?.bizs.length - 1 ? '، ' : ''
                    }`}</li>
                ))}
              </Typography>
            </Grid>
            <Grid
              container
              alignItems={data?.guilds.length === 0 ? 'center' : 'flex-start'}
              className={classes.tickItem}
            >
              <span className={classes.tickIcon}>
                <Icons icon='Accept' color='#4CAF50' size='22' />
              </span>
              <Typography className={classes.tickText}>
                {data?.guilds.length === 0
                  ? 'امکان استفاده از این اعتبار در تمامی حساب‌های تفصیلی وجود دارد.'
                  : `امکان استفاده از این اعتبار در حساب‌های تفصیلی زیر وجود دارد:`}
                <br />
                {data?.guilds.map((v, k) => (
                  <li key={k} className={classes.usageItem}>{`${v.value}${k < data?.guilds.length - 1 ? ' ،' : ''
                    }`}</li>
                ))}
              </Typography>
            </Grid>
            <Grid
              container
              alignItems={data?.products.length === 0 ? 'center' : 'flex-start'}
              className={classes.tickItem}
            >
              <span className={classes.tickIcon}>
                <Icons icon='Accept' color='#4CAF50' size='22' />
              </span>
              <Typography className={classes.tickText}>
                {data?.products.length === 0
                  ? 'امکان استفاده از این اعتبار بر روی تمامی محصولات وجود دارد.'
                  : `امکان استفاده از این اعتبار بر روی محصولات زیر وجود دارد:`}
                <br />
                {data?.products.map((v, k) => (
                  <li key={k} className={classes.usageItem}>{`${v.value} (${v.id})${k < data?.products.length - 1 ? ' ،' : ''
                    }`}</li>
                ))}
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
};

// See detail for every row

export default DetailPanel;
